export default __webpack_public_path__ + "static/media/mox.32398463.svg";